var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"community-wizard-view"},[_c('community-wizard',{attrs:{"is-owner-flow":_vm.isOwnerFlow},on:{"close":_vm.handleClose,"community-created":_vm.onCommunityCreated,"show-all-set-modal":_vm.onShowAllSetModal}}),(_vm.showAllSetModal)?_c('all-set-modal',{on:{"close":_vm.closeAllSetModal,"start-tour":_vm.startTour}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }